import { appBaseUrl } from "utils/config";
import { putService } from "services/commonServices";

export class InstanceSpecialChatServices {
  addOrDeleteParticipantInQuickGroupChatUpdate(id, body) {
    // let query = queryString.stringify(q);
    //console.log("id", id);
    let url = `${appBaseUrl}/mailMessageCenter/addOrDeleteParticipantInQuickGroupChatUpdate/${id}`;
    let data = putService(url, body, "put");
    return data;
  }
}
